module.exports = __webpack_public_path__ + "static/media/card4_9.5d150623.png";